import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import uploadData from "../services/uploadData";

const handleFetchUnits = async ({  params }: any) => {
  const uri = `v1/units?${params}`;
  const response = fetchData({ uri });
  return response;
};

const handleExportUnits = async () => {
  const uri = `v1/units/export`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchUnitsCount = async (id: any) => {
  const uri = `v1/units/count/all`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateUnit = async (data: any) => {
  const uri = `v1/units`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateUnit = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateUnitStatus = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}/status`;
  const response = patchData({ data, uri });
  return response;
};

const handleUpdateUnitShown = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}/shown`;
  const response = patchData({ data, uri });
  return response;
};

const handleAssignApprover = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}/approver/assign`;
  const response = patchData({ data, uri });
  return response;
};

const handleRemoveApprover = async ({ _id, data }: any) => {
  const uri = `v1/units/${_id}/approver/remove`;
  const response = patchData({ data, uri });
  return response;
};

const handleUploadUnits = async ({ data }: any) => {
  const uri = `v1/units/upload`;
  const response = uploadData({ data, uri });
  return response;
};

const handleDeleteUnit = async (data: any) => {
  const uri = `v1/units`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchUnits,
  handleExportUnits,
  handleCreateUnit,
  handleUpdateUnit,
  handleDeleteUnit,
  handleUploadUnits,
  handleAssignApprover,
  handleRemoveApprover,
  handleUpdateUnitStatus,
  handleUpdateUnitShown,
  handleFetchUnitsCount,
};
